import { render } from "./NoTrackingInfo.vue?vue&type=template&id=17922b0d&scoped=true&lang=pug"
import script from "./NoTrackingInfo.vue?vue&type=script&lang=ts"
export * from "./NoTrackingInfo.vue?vue&type=script&lang=ts"

import "./NoTrackingInfo.vue?vue&type=style&index=0&id=17922b0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17922b0d"

export default script